<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  			<li class="m-nav__item">
		  				<router-link :to="{name: 'home'}">
		  					<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
		  					</span>
		  				</router-link>
		  			</li>
		  			<li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{'cameras' | translate | titleize}}
		  					</span>
		  			</li>
            <li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  				<span class="m-nav__link-text">
		  					{{'manufactures' | translate | titleize}}
		  				</span>
		  			</li>
		  		</ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="la la-cubes"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{'manufactures' | translate | capitalize}}
              </h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
              <li class="m-portlet__nav-item">
                <a href="#" class="btn btn-success m-btn m-btn--icon" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#new_manufacturer_modal" @click="setStatusManufacturerModal(true)">
							    <span>
                    <i class="fa fa-plus"></i>
                    <span>
                      {{'create_manufacturer' | translate | capitalize }}
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-portlet__body">
          <s-datatable :config="datatable">
            <div slot="state" slot-scope="props">
              <a @click="manufacturerStatus(props.row.id, props.row.state == 1 ? 0 : 1)">
                <span v-tooltip="messageStateTooltip" v-if="props.row.state == 1" class="m-badge m-badge--success m-badge--wide">{{'active' | translate | capitalize}}</span>
                <span v-tooltip="messageStateTooltip" v-else class="m-badge m-badge--danger m-badge--wide">{{'inactive' | translate | capitalize}}</span>
              </a>
            </div>
            <div slot="actions" slot-scope="props">
              <a v-tooltip="messageEditTooltip" href="#" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit"  data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#new_manufacturer_modal" @click="editManufacturer(props.row)">
                <i class="la la-edit"></i>
              </a>
            </div>
          </s-datatable>
        </div>
        <s-modal id="new_manufacturer_modal" :title="edit ? 'edit_manufacturer' : 'create_manufacturer' | translate | capitalize">
          <s-new-manufacturer :data_send="data_modal" slot="body"></s-new-manufacturer>
        </s-modal>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SModal from '@/components/layout/modal/Modal.vue'
import SDatatable from '@/components/layout/datatable/Datatable.vue'
import SNewManufacturer from '@/components/admin/cameras/NewManufacturer.vue'
import swal from 'sweetalert'
export default {
  components: { SDatatable, SModal, SNewManufacturer },
  data () {
    return {
      datatable: {},
      messageStateTooltip: this.$options.filters.capitalize('manufacturer_state'),
      messageEditTooltip: this.$options.filters.capitalize('edit_record'),
      level: '',
      data_modal: {},
      edit: false
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusManufacturerModal', permissions: 'getUserPermissions', shard: 'getUserShard'})
  },
  mounted () {
    const datatable = {
      url: '/api/camera/manufacturer/list',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'name',
          title: 'name'
        },
        {
          field: 'structure',
          title: 'structure'
        }],
      actions: true,
      state: true,
      update: false,
      query: { }
    }
    this.datatable = datatable
  },
  methods: {
    ...mapActions([ 'setStatusManufacturerModal', 'inactivateManufacturer' ]),
    validPermission (code) {
      return this.permissions.find(p => { return (p.code === code) }) !== undefined
    },
    focusComponent () {

    },
    manufacturerStatus (manufacturer, state) {
      var msgTitle = this.$options.filters.capitalize('confirm_status_title')
      var msgText = this.$options.filters.capitalize('confirm_status_text')
      swal({
        title: msgTitle,
        text: msgText,
        icon: 'warning',
        dangerMode: true,
        buttons: {
          cancel: this.$options.filters.capitalize('cancel'),
          accept: {
            text: this.$options.filters.capitalize('accept'),
            willDelete: 'accept',
            closeModal: true
          }
        }
      }).then(willDelete => {
        if (willDelete) {
          let manu = { manufacturer: manufacturer, state: state }
          this.inactivateManufacturer(manu)
            .then((res) => {
              this.datatable.update = true
              this.$spinner.remove()
              if (res.status === 200) {
                this.$toast('status_manufacturer_message')
              }
            }).catch((err) => {
              this.$toast('status_manufacturer_error', 4)
              this.$spinner.remove()
              console.log(err)
            })
        }
      })
      this.$spinner.remove()
    },
    editManufacturer (manufacturer) {
      this.data_modal = manufacturer
      this.setStatusManufacturerModal(true)
      this.edit = true
    }
  },
  watch: {
    modal (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.datatable.update = true
        this.data_modal = {}
        this.edit = false
      }
    }
  }
}
</script>
<style>
.swal-button.swal-button--cancel {
    color: #555;
    background-color: #efefef;
    font-size: 12px;
    border: 1px solid #3e549a;
    text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
}
.swal-button.swal-button--accept {
  border-radius: 2px;
  background-color: #D21717;
  font-size: 12px;
  border: 1px solid #3e549a;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}
</style>


// WEBPACK FOOTER //
// Manufacturer.vue